'use client'

import React from "react";
import { motion } from 'framer-motion';
import { Typography, Container, CardContent, Grid } from '@mui/material';
import Link from "next/link";

export const PublikationSection = ({ data }) => {
    return (
        <motion.section
            className="section-large"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
        >
            <div className="section-header">
                <div className="section-title">
                    <Typography variant="h3" component="h1" gutterBottom>
                        Publikationen
                    </Typography>
                </div>
            </div>
            <div className="section-body">
                <Container maxWidth="full" className="no-padding">
                    {data && data.map((item, index) => (
                        <CardContent key={index} className="no-padding">
                            <Typography variant="h3" component="h2" color="text.secondary" gutterBottom>
                                {item.title} - {item.zeitraum}
                            </Typography>
                            <Grid container mb={2}>
                                {item.file_url !== null ?
                                    <Grid item xs={12}>
                                        <Typography variant="body1" paragraph>
                                            <Link href={item.file_url} underline="hover" target="_blank">
                                                {item.beschreibung}
                                            </Link>
                                        </Typography>
                                    </Grid>
                                    :
                                    <Grid item xs={12}>
                                        <Typography variant="body1" color="text.primary" paragraph>
                                            {item.beschreibung}
                                        </Typography>
                                    </Grid>
                                }
                            </Grid>
                        </CardContent>
                    ))}
                </Container>
            </div>
        </motion.section>
    );
};
